<template>
    <component v-if="mainNav.showNav" :is="currentNavType"></component>
</template>

<script>
    import { useMainNavStore } from '@/stores/mainNav';
    import { useScreenWidthStore } from '@/stores/utils/screenWidth';
    import { useUserStore } from '@/stores/user';
    import { useAccountStore } from '@/stores/account';
    import TopNav from '@/components/navigation/TopNav';
    import TopNavAccounts from '@/components/navigation/TopNavAccounts';
    import SideNav from '@/components/navigation/SideNav';

    import TopNavSearch from '@/components/navigation/TopNavSearch';

    export default {
        name: 'MainNav',
        components: {
            TopNav,
            TopNavAccounts,
            SideNav,
            TopNavSearch
        },
        computed: {
            mainNav() {
                return useMainNavStore();
            },
            screenWidthStore() {
                return useScreenWidthStore();
            },
            userStore() {
                return useUserStore();
            },
            accountStore() {
                return useAccountStore();
            },
            currentNavType() {
                if(this.accountStore.hasAccountId && this.accountStore.hasFullAccount && this.accountStore.account?.onboarding_status === 0) {
                    return 'TopNavAccounts';
                } else if (this.accountStore.account?.onboarding_status > 1) {
                    return 'none';
                } else if (this.accountStore.hasAccountId) {
                    if(this.screenWidthStore.width >= 769) {
                        return 'SideNav';
                    } else {
                        return 'TopNav';
                    }
                } else {
                    return 'TopNavAccounts';
                }
            },
        },
        methods: {
            toggleNav() {
                if (this.userStore.isAuthenticated) {
                    this.mainNav.toggleNav(true);
                } else {
                    this.mainNav.toggleNav(false);
                }
            },
        },
        watch: {
            $route() {
                this.toggleNav();
            }
        },
        created() {
            this.toggleNav();
        }
    }
</script>
